var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center fill-height"},[_c('Loader',{attrs:{"label":"Загрузка данных системы лицензирования..."}})],1):_c('v-card',{staticClass:"fill-height"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }